// Pagina's met de pageloader (components/parts/page-loader) zetten
// window.hellemaPageLoader: een promise die resolvet zodra de loader wegschuift.
// Reveal-animaties wachten daarop, anders spelen ze onzichtbaar achter de loader
// af. Op andere pagina's loopt alles meteen door.
export const whenPageRevealed = () => window.hellemaPageLoader || Promise.resolve();
